import styled from "styled-components";

import { size } from "~/styles/screen";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  row-gap: 12px;
`;

export const VaspCardContainer = styled.div`
  width: 100%;
  @media screen and (max-width: ${size.small}) {
    & {
      width: 100%;
      padding: 0 10px;
    }
  }
`;
